import { render, staticRenderFns } from "./tableHistorial.vue?vue&type=template&id=205b02ab&scoped=true&"
import script from "./tableHistorial.vue?vue&type=script&lang=js&"
export * from "./tableHistorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b02ab",
  null
  
)

export default component.exports